import { render, staticRenderFns } from "./quotaMaterial-detail-add-or-update.vue?vue&type=template&id=e4cf641e"
import script from "./quotaMaterial-detail-add-or-update.vue?vue&type=script&lang=js"
export * from "./quotaMaterial-detail-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports